<div
  class="checkout-step"
  [class.checkout-step--active]="isOpen()"
  [class.checkout-step--completed]="isCompleted() && !isOpen()"
  [class.checkout-step--pending]="!isCompleted() && !isOpen()"
  [class.checkout-step--last]="isLastStep()">

  <!-- Indicator: círculo de paso + línea conectora -->
  <div class="checkout-step__indicator" aria-hidden="true">
    <div class="checkout-step__circle">
      @if (isCompleted() && !isOpen()) {
        <svg class="checkout-step__check-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      } @else {
        <span class="checkout-step__number">{{ stepNumber() }}</span>
      }
    </div>
    @if (!isLastStep()) {
      <div class="checkout-step__connector"></div>
    }
  </div>

  <!-- Contenido del paso -->
  <div class="checkout-step__body">

    <!-- Header: solo título + summary -->
    <div class="checkout-step__header">
      <div class="checkout-step__title-group">
        <button
          type="button"
          class="checkout-step__title-btn"
          [disabled]="!allowToggle() || isOpen()"
          (click)="!isOpen() && allowToggle() && sectionToggle.emit()"
          [attr.aria-expanded]="isOpen()"
          [attr.aria-label]="title()">
          <h3 class="checkout-step__title mb-0">{{ title() }}</h3>
        </button>
        @if (isCompleted() && !isOpen() && summaryText()) {
          <p class="checkout-step__summary mb-0">{{ summaryText() }}</p>
        }
      </div>
    </div>

    <!-- Contenido expandido -->
    @if (isOpen()) {
      <div class="checkout-step__content">
        <ng-content></ng-content>
      </div>
      <div class="checkout-step__footer">
        <div class="checkout-step__actions">
          @if (backLinkText()) {
            <button
              type="button"
              class="checkout-step__back-btn"
              (click)="onBackLinkClick($event)">
              <svg class="checkout-step__back-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Volver
            </button>
          }
          <div class="checkout-step__actions-right">
            @if (secondaryActionText()) {
              <button
                type="button"
                class="btn btn-cancel text-uppercase"
                [disabled]="!canContinue()"
                (click)="secondaryConfirm.emit()">
                {{ secondaryActionText() }}
              </button>
            }
            @if (!hideContinue()) {
              <button
                type="button"
                class="btn btn-secondary text-uppercase"
                [disabled]="!canContinue()"
                (click)="confirm.emit()">
                {{ continueText() }}
              </button>
            }
          </div>
        </div>
      </div>
    }

  </div>
</div>
